<template>
  <!-- Experience Modal -->
  <div id="select_banked_user_modal" class="modal custom-modal fade" role="dialog" ref="myModal">
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Activity Filter</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" ref="Close">
            <i class="fas fa-times"></i>
          </button>
        </div>
        <div class="modal-body">
          <form>
            <div class="form-scroll">
              <div class="card">
                <div class="card-body">
                  <div class="row">
                    <h3 class="card-title">
                      Filter
                    </h3>


                    <div class="col-12">
                      <div class="mb-3">
                        <h6 class="mt-3">
                          User Type
                        </h6>
                        <div class="mt-3 d-flex flex-wrap gap-3">
                          <div class="form-check form-check-inline" v-for="option in userOptions" :key="option.value">
                            <input class="form-check-input" type="radio" :id="option.value" name="userType"
                              :value="option.value" v-model="userType" />
                            <label class="form-check-label" :for="option.value">{{ option.label }}</label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <h6 class="mt-3">
                        Select Location
                      </h6>
                      <div class="mt-3">
                        <v-autocomplete v-model="selectedLocations" :items="locationIdOptions" label="Locations"
                          multiple variant="outlined" density="comfortable" closable-chips item-title="text"
                          item-value="id" chips></v-autocomplete>
                      </div>

                    </div>


                    <div v-if="userType === 'user'">
                      <h6 class="mt-3">
                        Select Employees
                      </h6>
                      <div class=" col-12 mt-3">

                        <v-autocomplete v-model="selectedUsers" :items="usersData" label="Employees" multiple
                          variant="outlined" density="comfortable" item-title="text" item-value="id" closable-chips
                          chips></v-autocomplete>
                      </div>
                      <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                        <button class="btn btn-primary me-md-2" type="button" @click="selectClicked">Select All</button>
                        <button class="btn btn-primary" type="button" @click="unselectClicked">Unselect All</button>
                      </div>
                    </div>


                  </div>


                </div>
              </div>
            </div>


            <div class="submit-section">
              <button class="btn btn-primary submit-btn" type="button" @click="okClicked">Submit</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  <!-- /Experience Modal -->


</template>
<script>
// import { ref } from "vue";
import axios from 'axios';
import { VUE_APP_API_BASE_URL } from "../../config";
export default {
  props: {
    initialType: {
      type: String,
      default: ''
    },
    initialUsers: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      select2: null,

      perPage: 10,
      current: 1,
      total: 0,

      usersData: [],
      companyRole: [],
      locationIdOptions: [],
      loader: false,
      user: true,
      visitor: false,
      contractor: false,
      userType: '', // or default: 'staff'
      userOptions: [
        { label: 'Employee', value: 'user' },
        { label: 'Visitor', value: 'visitor' },
        { label: 'Contractor', value: 'contractor' }
      ],
      selectedUsers: [],
      selectedLocations: [],
      selectedRoles: [],
    };
  },
  mounted() {
    this.getUsers(),
      this.getLocationIds()
  },
  methods: {
    async getCompanyRoles() {
      await axios.get(`${VUE_APP_API_BASE_URL}/company-role/get`)
        .then((response) => {
          if (response.data.status) {
            this.companyRole = response.data.data
            this.companyRole.forEach(element => {
              delete element['created_at'];
              delete element['updated_at'];
              element['text'] = element['name'];
              delete element['name'];
            });
          } else {
            this.errorMessage = response.data.message ?? "";
          }
        }).catch(function (error) {
          console.log(error);
        });
    },

    async getLocationIds() {
      await axios.get(`${VUE_APP_API_BASE_URL}/location/all`)
        .then((response) => {
          if (response.data.status) {
            this.locationIdOptions = response.data.data
            this.locationIdOptions.forEach(element => {
              delete element['created_at'];
              delete element['updated_at'];
              delete element['latitude'];
              delete element['longitude'];
              element['text'] = element['name'];
              delete element['name'];
            }
            )
          } else {
            this.errorMessage = response.data.message ?? "";
          }
        }).catch(function (error) {
          console.log(error);
        })
        .finally(() => {

        });
    },

    getUsers() {
      this.loader = true;

      axios.get(`${VUE_APP_API_BASE_URL}/user/user-list`)
        .then((response) => {
          if (response.data.status) {
            this.usersData = response.data.data;

            this.usersData.forEach(element => {
              element["text"] = element["first_name"] + " " + element["last_name"];
            });
          } else {
            this.errorMessage = response.data.message ?? "";
          }
        })
        .finally(() => {
          this.loader = false;
        });
    },

    unselectClicked() {
      this.selectedUsers = null;
    },
    selectClicked() {
      this.selectedUsers = this.usersData.map(user => user.id);
    },

    okClicked() {
      if (this.userType === 'staff' && this.selectedUsers.length == 0) {
        this.$toast.error("No users selected");
        return;
      }

      this.$emit('onUsersSelected', {
        type: this.userType,
        selectedUsers: this.selectedUsers,
        selectedLocations: this.selectedLocations
      });
      this.selectedUsers = [];
      this.selectedLocations = [];
      this.selectedRoles = [];
      this.$refs.Close.click();
    },
  },
  watch: {
    initialType: {
      handler(val) {
        if (val) this.userType = val;
      },
      immediate: true
    },
    initialUsers: {
      handler(val) {
        if (val && val.length > 0) this.selectedUsers = [...val];
      },
      immediate: true
    }
  },
};
</script>
